import React, { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
// import Button from '@mui/material/Button';
import { Grid, Typography } from '@material-ui/core';
import { styled } from '@mui/material/styles';
import useStyles from '../../../../StyleComponents/StyleFunctionComponent';
import { AppBar, Toolbar, IconButton, Modal, Box, TextField, Button } from "@material-ui/core";
import CloseIcon from '@mui/icons-material/Close';
import axios from 'axios'; // Import Axios

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
    '& .MuiDialog-paper': {
        minWidth: 600,
        maxWidth: 800,
        overflowY: 'auto',
        overflowX: 'hidden',
    },
}));

const UpdateDialog = ({ selectedRow, setSelectedRow, handleClose }) => {
    const [formData, setFormData] = useState({
        name: selectedRow.name,
        body: selectedRow.body,
        tractorNOC: selectedRow.tractorNOC, // Add this line
        tractorRC: selectedRow.tractorRC,
        tractorMonth: selectedRow.tractorMonth, // Add this line
        tractorHours: selectedRow.tractorHours, // Add this line
    });


    const handleFormChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };

    const handleFormSubmit = async (e) => {
        e.preventDefault();

        try {
            // Send a PUT request to your API endpoint
            const response = await axios.put(`http://localhost:3003/users/${selectedRow.id}`, formData);

            if (response.status === 200) {
                // Update was successful
                console.log('Update successful');
            } else {
                // Handle errors
                console.error('Update failed');
            }
        } catch (error) {
            console.error('Error:', error);
        }

        // Close the dialog
        handleClose();
    };

    const classes = useStyles();

    return (
        <BootstrapDialog open={Boolean(selectedRow)} onClose={handleClose}>
            <Grid container spacing={3}>
                <Grid xs={6} lg={6}>
                    <DialogTitle sx={{ m: 0, pl: 4 }} id="customized-dialog-title">
                        <Typography className={classes.tabletittle}>
                            Tractor Details
                        </Typography>
                    </DialogTitle>
                </Grid>
                <Grid xs={6} lg={6} style={{ margin: "auto", padding: "auto", textAlign: "right" }}>
                    <IconButton
                        aria-label="close"
                        onClick={handleClose}
                        style={{ marginRight: "10px" }}
                    >
                        <CloseIcon />
                    </IconButton>
                </Grid>
            </Grid>
            <DialogContent dividers>
                <form onSubmit={handleFormSubmit}>
                    {/* <div>
                        <label>Name:</label>
                        <input
                            className={classes.inputform}
                            type="text"
                            name="name"
                            value={formData.name}
                            onChange={handleFormChange}
                        />
                    </div>
                    <div>
                        <label>Body:</label>
                        <input
                            type="text"
                            name="body"
                            value={formData.body}
                            onChange={handleFormChange}
                        />
                    </div> */}



                    <Grid container spacing={2} >
                        <Grid item xs={6} sm={6} lg={6} >
                            <label for="birthday" className={classes.labelform}>Brand</label><br />
                            <input
                                placeholder='Brand'
                                className={classes.inputform}
                                type="text"
                                label="Search"
                                name="name"
                                value={formData.name}
                                onChange={handleFormChange}
                            />
                        </Grid>
                        <Grid item xs={6} sm={6} lg={6} >
                            <label for="birthday" className={classes.labelform}>Model</label><br />
                            <input
                                placeholder='Model'
                                className={classes.inputform}
                                type="text"
                                label="Search"
                            />
                        </Grid>
                        <Grid item xs={3} sm={3} lg={3} >
                            <label for="birthday" className={classes.labelform}>Tractor Year</label><br />
                            <input
                                placeholder='Tractor Year'
                                className={classes.inputform}
                                type="text"
                                label="Search"
                            />
                        </Grid>
                        <Grid item xs={3} sm={3} lg={3}>
                            <label for="tractorMonth" className={classes.labelform}>Tractor Month</label><br />
                            <select
                                id="tractorMonth"
                                name="tractorMonth"
                                form="carform"
                                className={classes.selectform}
                                value={formData.tractorMonth}
                                onChange={handleFormChange}
                            >
                                <option value="January">January</option>
                                <option value="February">February</option>
                                <option value="March">March</option>
                                <option value="April">April</option>
                                <option value="May">May</option>
                                <option value="June">June</option>
                                <option value="July">July</option>
                                <option value="August">August</option>
                                <option value="September">September</option>
                                <option value="October">October</option>
                                <option value="November">November</option>
                                <option value="December">December</option>
                            </select>
                        </Grid>
                        <Grid item xs={6} sm={6} lg={6} >
                            <label for="birthday" className={classes.labelform}>Tractor Year</label><br />
                            <input
                                placeholder='Tractor Year'
                                className={classes.inputform}
                                type="text"
                                label="Search"
                            />


                        </Grid>
                        <Grid item xs={6} sm={6} lg={6}>
                            <label for="tractorHours" className={classes.labelform}>Hours</label><br />
                            <select
                                id="tractorHours"
                                name="tractorHours"
                                form="carform"
                                className={classes.selectform}
                                value={formData.tractorHours}
                                onChange={handleFormChange}
                            >
                                <option value="Less than 500 Hrs">Less than 500 Hrs</option>
                                <option value="500 - 1000 Hrs">500 - 1000 Hrs</option>
                                <option value="1001 - 2000 Hrs">1001 - 2000 Hrs</option>
                                <option value="2001 - 3000 Hrs">2001 - 3000 Hrs</option>
                                <option value="3001 - 4000 Hrs">3001 - 4000 Hrs</option>
                                <option value="4001 - 5000 Hrs">4001 - 5000 Hrs</option>
                                <option value="5001 - 6000 Hrs">5001 - 6000 Hrs</option>
                                <option value="6001 - 7000 Hrs">6001 - 7000 Hrs</option>
                                <option value="7001 - 8000 Hrs">7001 - 8000 Hrs</option>
                                <option value="8001 - 9000 Hrs">8001 - 9000 Hrs</option>
                                <option value="9001 - 10000 Hrs">9001 - 10000 Hrs</option>
                                <option value="above 10000 Hrs">above 10000 Hrs</option>
                                <option value="Not Available Hrs">Not Available Hrs</option>
                            </select>
                        </Grid>

                        <Grid item xs={4} sm={4} lg={4} >
                            <label for="birthday" className={classes.labelform}>Exact HP</label><br />
                            <input
                                placeholder='Exact HP'
                                className={classes.inputform}
                                type="text"
                                label="Search"
                            />
                        </Grid>
                        <Grid item xs={4} sm={4} lg={4}>
                            <label for="tractorNOC" className={classes.labelform}>Tractor NOC</label><br />
                            <select
                                id="tractorNOC"
                                name="tractorNOC"
                                form="carform"
                                className={classes.selectform}
                                value={formData.tractorNOC}
                                onChange={handleFormChange}
                            >
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                            </select>
                        </Grid>

                        <Grid item xs={4} sm={4} lg={4}>
                            <label for="tractorRC" className={classes.labelform}>Tractor RC</label><br />
                            <select
                                id="tractorRC"
                                name="tractorRC"
                                form="carform"
                                className={classes.selectform}
                                value={formData.tractorRC}
                                onChange={handleFormChange}
                            >
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                            </select>
                        </Grid>
                        <Grid item xs={4} sm={4} lg={4} >
                            <label for="birthday" className={classes.labelform}>Tractor Owner</label><br />
                            <select id="cars" name="carlist" form="carform"
                                className={classes.selectform} >
                                <option value="yes">Yes</option>
                                <option value="one" selected="">One</option>
                                <option value="two">Two</option>
                                <option value="three">Three</option>
                                <option value="more_than_three">More_than_three</option>

                            </select>
                        </Grid>
                        <Grid item xs={6} sm={6} lg={6} >
                            <label for="birthday" className={classes.labelform}>Tyre Condition
                            </label><br />
                            <select id="cars" name="carlist" form="carform"
                                className={classes.selectform} >
                                <option value="0-25% (Poor)">0-25% (Poor)</option>
                                <option value="26-50% (Average)">26-50% (Average)</option>
                                <option value="51-75% (Good)">51-75% (Good)</option>
                                <option value="76-100% (Very Good)">76-100% (Very Good)</option>

                            </select>
                        </Grid>

                        <Grid item xs={6} sm={6} lg={6} >
                            <label for="birthday" className={classes.labelform}>Engine Condition</label><br />
                            <select id="cars" name="carlist" form="carform"
                                className={classes.selectform} >
                                <option value="0-25% (Poor)">0-25% (Poor)</option>
                                <option value="26-50% (Average)">26-50% (Average)</option>
                                <option value="51-75% (Good)">51-75% (Good)</option>
                                <option value="76-100% (Very Good)">76-100% (Very Good)</option>
                            </select>
                        </Grid>
                        <Grid item xs={12} sm={12} lg={12} >
                            <label for="birthday" className={classes.labelform}>About Us</label><br />
                            <input
                                placeholder='About Us'
                                className={classes.inputform}
                                type="text"
                                label="Search"
                            />
                        </Grid>
                        <Grid item xs={6} sm={6} lg={6} >
                            <label for="birthday" className={classes.labelform}>Live Status</label><br />
                            <select id="cars" name="carlist" form="carform"
                                className={classes.selectform} >
                                <option value="1">Active</option>
                                <option value="0" selected="">Inactive</option>
                            </select>
                        </Grid>
                        <Grid item xs={6} sm={6} lg={6} >
                            <label for="birthday" className={classes.labelform}>Sold Status</label><br />
                            <select id="cars" name="carlist" form="carform"
                                className={classes.selectform} >
                                <option value="1">Sold</option>
                                <option value="0" selected="">Unsold</option>

                            </select>
                        </Grid>
                    </Grid>
                    <Grid style={{ margin: "auto", padding: "auto", textAlign: "center" }}>
                        <br />
                        <Button
                            type="submit"
                            className={classes.buttonform}
                            color="primary">
                            Submit
                        </Button>
                        <Button
                            style={{ backgroundColor: "#dc3545", borderColor: '#dc3545', marginLeft: "10px" }}

                            onClick={handleClose}
                            color="primary"
                            // style={{ backgroundColor: "#dc3545", borderColor: '#dc3545' }}
                            className={classes.buttonform}
                        >
                            Close
                        </Button>
                    </Grid>
                </form>
            </DialogContent>
        </BootstrapDialog>
    );
};

export default UpdateDialog;


